function getPresenceDisplayName(sessionId, hubChannel) {
  return sessionId ? hubChannel?.presence?.state?.[sessionId]?.metas?.[0]?.profile?.displayName : null;
}

export function resolveDialogChatDisplayName(message = {}, hubChannel = null) {
  return getPresenceDisplayName(message?.senderSessionId, hubChannel) || message?.senderName || "Mystery user";
}

function buildPrivateChatBody(message = {}, hubChannel = null) {
  const sender = resolveDialogChatDisplayName(message, hubChannel);
  const agentUuid =
    message?.agentUuid ||
    (typeof message?.senderSessionId === "string" && message.senderSessionId.startsWith("agent:")
      ? message.senderSessionId.slice("agent:".length)
      : undefined);
  const receiver = agentUuid ? agentUuid : message?.recipientSessionId || message?.receiver;

  const body = {
    message: message?.text || "",
    receiver,
    sender,
    senderSessionId: message?.senderSessionId,
    clientMessageId: message?.clientMessageId,
    privacyType: "private-chat"
  };

  if (agentUuid) {
    body.agentUuid = agentUuid;
    body.senderType = "agent";
  }

  return body;
}

export function buildDialogChatPresenceEntry(message = {}, hubChannel = null) {
  const currentSessionId =
    hubChannel?.channel?.socket?.params?.()?.session_id || (typeof NAF !== "undefined" ? NAF.clientId : null);
  const sessionId = message?.senderSessionId;
  const isPrivateLike = message?.conversationType === "private" || message?.conversationType === "agent";

  return {
    name: resolveDialogChatDisplayName(message, hubChannel),
    type: "chat",
    body: isPrivateLike ? buildPrivateChatBody(message, hubChannel) : message?.text || "",
    maySpawn: false,
    sessionId,
    sent: Boolean(sessionId && sessionId === currentSessionId),
    createdAt: message?.createdAt,
    idempotencyKey: message?.idempotencyKey
  };
}
